import { DataCollection } from "@app/classes/infrastructure/datacollection";
import { DataContainerService } from "@app/classes/infrastructure/datacontainer.service";
import { RequestTypes } from "@app/classes/infrastructure/enums";
import { TransportData } from "@app/classes/infrastructure/transportdata";
import { Utils } from "@app/services/utils.service";

export class TodaysTaskFetchRequest {
  public static readonly FetchRequestType: string = "todays_work_summery_fetch_request";

  // Hierarchy filters
  state_ids: number[] = [];
  zone_ids: number[] = [];
  district_ids: number[] = [];
  block_ids: number[] = [];
  phc_ids: number[] = [];
  sc_ids: number[] = [];
  village_ids: number[] = [];
  asha_ids: number[] = [];
  af_ids: number[] = [];
  asha_employee_record_ids: number[] = [];
  asha_post_ids: number[] = [];

  af_employee_record_ids: number[] = [];
  af_post_ids: number[] = [];

  bcm_employee_record_ids: number[] = [];
  bcm_post_ids: number[] = [];

  dcm_employee_record_ids: number[] = [];
  dcm_post_ids: number[] = [];

  // Today's task is always for "today", so no report_filter_type / month / quarter / half-year.
  // Server fills this in the response (e.g. "13/10/2026").
  as_on_date_formatted: string = "";

  public MergeIntoTransportData = (td: TransportData) => {
    let coll = DataContainerService.GetInstance().GetOrCreateCollection(
      td.MainData,
      TodaysTaskFetchRequest.FetchRequestType
    ) as DataCollection;
    coll.Entries.push(this);
  };

  public FormulateTransportData = () => {
    let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
    this.MergeIntoTransportData(td);

    return td;
  };
}